{
  "ar-SA": 94,
  "az-AZ": 17,
  "bg-BG": 71,
  "bn-BD": 52,
  "ca-ES": 83,
  "cs-CZ": 86,
  "da-DK": 61,
  "de-DE": 100,
  "el-GR": 80,
  "en": 100,
  "es-ES": 96,
  "eu-ES": 97,
  "fa-IR": 84,
  "fi-FI": 76,
  "fr-FR": 99,
  "gl-ES": 86,
  "he-IL": 77,
  "hi-IN": 76,
  "hu-HU": 76,
  "id-ID": 91,
  "it-IT": 98,
  "ja-JP": 90,
  "kaa": 36,
  "kab-KAB": 76,
  "kk-KZ": 18,
  "km-KH": 83,
  "ko-KR": 100,
  "ku-TR": 87,
  "lt-LT": 48,
  "lv-LV": 77,
  "mr-IN": 98,
  "my-MM": 35,
  "nb-NO": 93,
  "nl-NL": 75,
  "nn-NO": 67,
  "oc-FR": 92,
  "pa-IN": 78,
  "pl-PL": 99,
  "pt-BR": 91,
  "pt-PT": 83,
  "ro-RO": 99,
  "ru-RU": 92,
  "si-LK": 7,
  "sk-SK": 100,
  "sl-SI": 100,
  "sv-SE": 100,
  "ta-IN": 81,
  "th-TH": 44,
  "tr-TR": 87,
  "uk-UA": 93,
  "vi-VN": 49,
  "zh-CN": 100,
  "zh-HK": 22,
  "zh-TW": 100
}
